import { render, staticRenderFns } from "./GiftMenu.vue?vue&type=template&id=6c53ae70&scoped=true"
import script from "./GiftMenu.vue?vue&type=script&lang=js"
export * from "./GiftMenu.vue?vue&type=script&lang=js"
import style0 from "./GiftMenu.vue?vue&type=style&index=0&id=6c53ae70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c53ae70",
  null
  
)

export default component.exports